import { z } from "zod"

export const CreateGuideSchema = z.object({
  name: z.string(),
})
export const UpdateGuideSchema = CreateGuideSchema.merge(
  z.object({
    id: z.number(),
  })
)

export const DeleteGuideSchema = z.object({
  id: z.number(),
})

export const CreateGuidePlaceSchema = z.object({
  guideId: z.number(),
  googlePlaceId: z.string(),
})
